import { AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import { useEffect } from 'react';
import { Page } from '../../../../../../components/page/page';
import { Card } from '../../../../../../components/card/card';
import { Button } from '../../../../../../components/button/button';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Tooltip } from '../../../../../../features/tooltip/tooltip';
import { Table } from '../../../../../../features/table/table';
import { TableFilterInput } from '../../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterMultiSelect } from '../../../../../../features/table/table-filter/table-filter-multi-select/table-filter-multi-select';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { useExternalReviewsStore } from '../../../../../../store/use-external-reviews-store';
import { useExternalReviewResourcesStore } from '../../../../../../store/use-external-review-resources-store';
import { CreateExternalReviewModal } from '../create/create-external-review-modal';
import { EditExternalReviewModal } from '../create/edit-external-review-modal';
import { DeleteExternalReviewModal } from '../create/delete-external-review-modal';
import { getSocialIcon } from '../../../../../../helpers/icon-maps';
import s from '../../review-sources.module.css';

const sourceNameToIcon = (name?: string) => {
  const key = (name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');

  const map: Record<string, string> = {
    '2gis': '2gis',
    instagram: 'instagram',
    vk: 'vk',
    facebook: 'facebook',
    tiktok: 'tiktok',
    youtube: 'youtube',
    googlemaps: 'googlemaps',
    yandexmaps: 'yandexmaps',
    otzovik: 'otzovik',
    yandexmarket: 'yandexmarket',
    kaspimarket: 'kaspi',
    wildberries: 'wildberries',
    ozon: 'ozon',
    linkedin: 'linkedin',
  };

  return map[key] || key;
};

export const ReviewSources = () => {
  const { t } = useLang();
  const { externalReviews, pagination, isLoadingFetch, fetchExternalReviews } = useExternalReviewsStore();
  const { resources, fetchResources } = useExternalReviewResourcesStore();
  const createModal = useModalParams('createExternalReview');
  const editModal = useModalParams('editExternalReview');
  const deleteModal = useModalParams('deleteExternalReview');

  // Загрузка списка источников при открытии страницы
  useEffect(() => {
    fetchExternalReviews({});
    fetchResources();
  }, [fetchExternalReviews, fetchResources]);

  return (
    <Page className={s.page}>
    <div className={s.header}>
      <div></div>
      <Button size="lg" onClick={() => createModal.handleOpenModal()}>
        <AiOutlinePlus />
        <span className="hide__M hide__S">{t('Внешний источник')}</span>
      </Button>
    </div>
    <Card>
      <Table
        id="reviews"
        className={s.sourcesTable}
        columnSettings
        withArchive
        pagination={pagination}
        isLoading={isLoadingFetch}
        onEmpty={{
          title: t('Список внешних отзывов пуст'),
          text: t('Добавьте внешние отзывы для мониторинга'),
        }}
        cols={{
          source: {
            label: t('Тип источника'),
            width: 160,
            filter: (
              <TableFilterInput
                name="source"
                suggestOptions={externalReviews
                  ?.map((item) => resources.find((r) => r.id === item.type)?.name)
                  .filter((name): name is string => Boolean(name))}
              />
            ),
          },
          source_url: {
            label: t('Ссылка на источник'),
            filter: (
              <TableFilterInput
                name="source_url"
                suggestOptions={externalReviews?.map((item) => item.source_url)}
              />
            ),
          },
          collection_frequency: {
            label: t('Периодичность сбора'),
            width: 210,
            filter: (
              <TableFilterMultiSelect
                options={[
                  { id: '1', value: '1' },
                  { id: '2', value: '2' },
                  { id: '3', value: '3' },
                  { id: '4', value: '4' },
                  { id: '5', value: '5' },
                ]}
                name="collection_frequency"
              />
            ),
          },
          // branch: {
          //   label: t('Филиал'),
          //   filter: (
          //     <TableFilterSingleSelect
          //       options={branches?.map((item) => ({
          //         id: String(item.id),
          //         value: getLocale(item.name),
          //       }))}
          //       name="place_id"
          //     />
          //   ),
          // },
          // is_active: {
          //   label: t('Статус'),
          //   filter: (
          //     <TableFilterMultiSelect
          //       options={[
          //         { id: 'true', value: t('Активен') },
          //         { id: 'false', value: t('Выключен') },
          //       ]}
          //       name="is_active"
          //     />
          //   ),
          // },
          actions: { label: t('Действия'), width: 112 },
        }}
        rows={externalReviews?.map((item) => ({
          rowId: item.id,
          source: item.type ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span style={{ display: 'flex', alignItems: 'center' }}>
                {getSocialIcon(sourceNameToIcon(resources.find((r) => r.id === item.type)?.name))}
              </span>
              <span>{resources.find((r) => r.id === item.type)?.name || '-'}</span>
            </div>
          ) : null,
          source_url: item.source_url ? (
            <Tooltip
              behavior="hover"
              position="bottom"
              offset={10}
              wrapperClassName={s.sourceUrlTooltipRoot}
              triggerWrapperClassName={s.sourceUrlTooltipTrigger}
              optionsWrapperClassName={s.sourceUrlTooltipPopup}
              trigger={
                <a
                  className={s.sourceUrlCell}
                  href={item.source_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.source_url}
                </a>
              }
            >
              <div className={s.sourceUrlTooltipBody}>{item.source_url}</div>
            </Tooltip>
          ) : (
            '-'
          ),
          collection_frequency: item.collection_frequency,
          // branch: getLocale(branches?.find((branch) => branch.id === item.place_id)?.name),
          // is_active: (
          //   <Checkbox
          //     checked={item.is_active}
              
          //     label={item.is_active ? t('Активен') : t('Завершено')}
          //   />
          // ),
          actions: (
            <div className={s.actions}>
              <IconButton
                tooltip={t('Редактировать')}
                variant="secondary"
                size="sm"
                onClick={() => editModal.handleOpenModal({ reviewId: String(item.id) })}
              >
                <AiOutlineEdit />
              </IconButton>
              <IconButton
                tooltip={t('Удалить')}
                variant="secondary"
                size="sm"
                onClick={() => deleteModal.handleOpenModal({ reviewId: String(item.id) })}
              >
                <AiOutlineDelete />
              </IconButton>
            </div>
          ),
        }))}
      />
    </Card>
    {createModal.isOpen && (
      <CreateExternalReviewModal onClose={() => createModal.handleCloseModal()} />
    )}
    {editModal.isOpen && (
      <EditExternalReviewModal
        onClose={() => editModal.handleCloseModal(['reviewId'])}
      />
    )}
    {deleteModal.isOpen && (
      <DeleteExternalReviewModal
        onClose={() => deleteModal.handleCloseModal(['reviewId'])}
      />
    )}
    </Page>
  );
};
